import React from 'react';

import ReportCardSubheading from '/component/base/ReportCardSubheading';
import Text from '/component/base/Text';
import OrderHistoryReportContent from '/component/partial/reportCard/OrderHistoryReportContent';
import {UserProfileModal} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {getDateUtilDefaultInstance} from '/util/date.util';

// Define the expected structure for recordData
interface RecordData {
  activatedOn: string; // Assuming activatedOn is a string (ISO date format)
}

// Define props interface manually
interface NewClientsWithoutOrdersReportContentProps {
  tt: (key: string, defaultValue?: string) => string;
  recordData: RecordData;
}

export const NewClientsWithoutOrdersReportContent: React.FC<
  NewClientsWithoutOrdersReportContentProps
> = ({tt, recordData = {activatedOn: ''}}) => {
  return (
    <>
      <ReportCardSubheading
        label={tt('label.dateJoined', 'Date Joined')}
        value={
          <Text variant="large" testID={UserProfileModal.joinedDate}>
            {getDateUtilDefaultInstance().formatDate(
              recordData.activatedOn,
              'MMMM d, yyyy',
            )}
          </Text>
        }
      />
      <OrderHistoryReportContent recordData={recordData} />
    </>
  );
};

export const RawNewClientsWithoutOrdersReportContent =
  NewClientsWithoutOrdersReportContent;

export default withTranslation('report.newClientsWithoutOrders.content')(
  NewClientsWithoutOrdersReportContent,
);
